module.exports = __webpack_public_path__ + "static/media/wirt-crop.be00e814.png";